const NotFound = () => {
  return (
    <>
      <p>Not found</p>
    </>
  );
};

export default NotFound;
